<template>
  <div class="car-detail-contact-form w-full my-16 lg:my-32 flex flex-col gap-5 lg:grid lg:grid-cols-[1fr_520px] lg:gap-8 xl:gap-10 relative">
    <div id="car-detail-contact-form-marker" class="absolute -top-24 left-0 w-0 h-0"></div>
    <PageComponentsContactForm
      :component="{
        __typename: 'ComponentPageComponentsContactForm',
        contactFormTitle: component?.carDetailContactFormTitle,
        contactFormDescription: component?.carDetailContactFormDescription,
      }"
      :index="index"
    />
    <!--
      Portrait is cropped per breakpoint from a single source: square on mobile,
      tall portrait (up to 520x845) on desktop. Rendered directly rather than via
      PageComponentsImage, whose shared aspect-square would force both to square.
    -->
    <figure v-if="component?.carDetailContactFormImage" class="car-detail-contact-form__image hidden lg:block">
      <SharedPicture
        :media="component.carDetailContactFormImage"
        :loading="index > 3 ? 'lazy' : 'eager'"
        width="520"
        height="845"
        format="webp"
        :quality="85"
        fit="cover"
      />
    </figure>
    <figure v-if="component?.carDetailContactFormImage" class="car-detail-contact-form__image block lg:hidden">
      <SharedPicture
        :media="component.carDetailContactFormImage"
        :loading="index > 3 ? 'lazy' : 'eager'"
        width="750"
        height="750"
        format="webp"
        :quality="85"
        fit="cover"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLCarDetail } from '~/types/graphql';

  defineProps<{
    component: GraphQLCarDetail;
    index: number;
  }>();
</script>

<style lang="scss" scoped>
  @screen lg {
    .car-detail-contact-form {
      :deep(.contact-form) {
        gap: 1rem;
      }

      :deep(.contact-form__header) {
        gap: 0;
      }

      :deep(.contact-form__title) {
        font-size: 24px;
        text-align: left;
      }

      .car-detail-contact-form__image {
        height: 100%;
      }
    }
  }

  .car-detail-contact-form__image {
    @apply rounded-sm overflow-hidden;

    :deep(picture),
    :deep(img) {
      @apply w-full h-full object-cover;
    }
  }
</style>
